import { useEffect } from 'react';
import { useShellShimReact } from './useShellShimReact';
export var useOnThemeChanged = function (callback) {
    var shellShim = useShellShimReact();
    useEffect(function () {
        shellShim === null || shellShim === void 0 ? void 0 : shellShim.Theme.OnThemeChanged(callback, true /* auto-invoke */);
        return function () {
            shellShim === null || shellShim === void 0 ? void 0 : shellShim.Theme.RemoveOnThemeChanged(callback);
        };
    }, [callback, shellShim === null || shellShim === void 0 ? void 0 : shellShim.Theme]);
};
//# sourceMappingURL=useOnThemeChanged.js.map